export default __webpack_public_path__ + "2fb0418d93fa8fccbe2347c34dfe1834.svg";